import React from 'react';

import redirect from '@/utils/legacy/redirect';

import {
	BodyText,
	Content,
	ContentTitle,
	Description,
	Heading,
	TileImage,
	TileImageContainer,
	Wrapper,
} from './styles';

type ContentSlideProps = {
	heading: string;
	description: string;
	tileUrl: string;
	tileImage: string;
	tileTitle: string;
	tileDescription: string;
};

const ContentSlide = ({
	heading,
	description,
	tileUrl,
	tileImage,
	tileTitle,
	tileDescription,
}: ContentSlideProps) => {
	return (
		<Wrapper onClick={(): void => redirect(tileUrl)}>
			<TileImageContainer>
				<TileImage src={tileImage} alt={tileTitle} />
			</TileImageContainer>
			<Content>
				<Heading>{heading}</Heading>
				<Description>{description}</Description>
				<ContentTitle>{tileTitle}</ContentTitle>
				<BodyText>{tileDescription}</BodyText>
			</Content>
		</Wrapper>
	);
};

export default ContentSlide;
